import { gantt, Id } from "@planzone/dto";
import { Selector, State } from "./types";

function get(getState: () => State, zoneId: Id) {
  return getState().find((res) => res.zone.uuid === zoneId);
}

function queryState(getState: () => State, projectId: Id) {
  return <Result>(
    query: (res: State[number]) => Result,
    fallBack: Result,
  ): Result => {
    const state = get(getState, projectId);

    return state ? query(state) : fallBack;
  };
}

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveZoneGanttRequestFailure({ uuid }) {
      return queryState(getState, uuid)((res) => res.request.isFailure, false);
    },
    isRetrieveZoneGanttRequestPending({ uuid }) {
      return queryState(getState, uuid)((res) => res.request.isPending, false);
    },
    isRetrieveZoneGanttRequestSuccess({ uuid }) {
      return queryState(getState, uuid)(
        (res) => res.request.isSuccessful,
        false,
      );
    },
    getZoneGantt({ uuid }) {
      return queryState(getState, uuid)((res) => res.gantt, gantt);
    },
  };
}

export { createSelector };
